export interface IRejectionReasonAmbulance {
  id?: string;
  enRejectionReason?: string;
  stRejectionReason?: string;
  countryId?: string;
  rejectionReasonAmbulanceCountryId?: string;
  isActive?: boolean;
}

export const defaultValue: Readonly<IRejectionReasonAmbulance> = {};
